<template>
    <section class="my-4 mx-4">
        <h3 class="p-4 text-lg font-bold">Payment Method</h3>
        <div
            v-if="!current.brand"
            class="bg-gray-light py-4 px-8 rounded flex items-center"
        >
            <div class="py-2 px-4 rounded-md bg-white text-destructive">
                ⚠️ No payment method available
            </div>
            <a
                :href="billingPortalUrl"
                class="py-2 px-4 rounded-md bg-primary-lighter text-primary font-bold ml-2"
                target="_blank"
            >
                <strong>Add card</strong>
            </a>
        </div>
        <div v-else class="bg-gray-light py-4 px-8 rounded flex items-center">
            <div class="py-2 px-4 rounded-md bg-white text-prim font-bold">
                <font-awesome-icon
                    :icon="cardIcon"
                    class="text-primary"
                ></font-awesome-icon>
                <span class="hidden md:inline-block">**** **** ****</span>
                {{ current.last_4 }}
            </div>
            <button
                class="py-2 px-4 rounded-md bg-primary-lighter text-primary font-bold ml-2"
                :loading="false"
                :state="'...'"
                @click="change"
            >
                <strong>Update card</strong>
            </button>
        </div>
    </section>
</template>

<script>
import ChangeCardModal from "./ChangeCardModal";

export default {
    props: {
        billingPortalUrl: {
            type: String,
            required: true,
        },
        card: {
            type: Object,
            required: true,
        },
        endpoint: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            current: this.card,
        };
    },
    computed: {
        cardIcon() {
            const defaultIcon = ["fas", "credit-card"];
            if (!this.current) {
                return defaultIcon;
            }

            switch (this.current.brand) {
                case "amex":
                    return ["fab", "cc-amex"];
                case "diners":
                    return ["fab", "cc-diners-club"];
                case "jcb":
                    return ["fab", "cc-jcb"];
                case "discover":
                    return ["fab", "cc-discover"];
                case "mastercard":
                    return ["fab", "cc-mastercard"];
                case "visa":
                    return ["fab", "cc-visa"];
                default:
                    return defaultIcon;
            }
        },
    },
    methods: {
        change() {
            Modal.show(ChangeCardModal, {
                propsData: {
                    card: this.current,
                    endpoint: this.endpoint,
                },
            })
                .then((updated) => {
                    this.current = updated;
                })
                .catch((err) => {
                    console.error(err);
                });
        },
    },
};
</script>
